__turbopack_context__.v({
  "blogComponentContent": "blogPress-module-scss-module__5mYbcG__blogComponentContent",
  "blogComponentPressItem": "blogPress-module-scss-module__5mYbcG__blogComponentPressItem",
  "blogComponentPressItemTitle": "blogPress-module-scss-module__5mYbcG__blogComponentPressItemTitle",
});
